import React from 'react';

import 'bootstrap/dist/css/bootstrap.min.css';

import MainLogo from '../Logo/Logo_b.png';

class Contact extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			
	}
	}

	render() {
		return (
			<div>
			{/* <div style={{ textAlign: 'right', alignSelf: 'stretch' }}>{',fortunae'}</div> */}
			<div style={{ textAlign: 'right', alignSelf: 'stretch' }}>
				{
					'.האתר הוקם כדי לתת מענה מהיר ונוח להשוואת מחירי ניהול ותשואות  של קרנות סל וקרנות נאמנות'
				}
			</div>
			<div style={{ textAlign: 'right', alignSelf: 'stretch' }}>{':ליצירת קשר'}</div>
			<div style={{ textAlign: 'right', alignSelf: 'stretch' }}>{'nitsan57@gmail.com'}</div>
			<div style={{ textAlign: 'right', alignSelf: 'stretch' }}>{'orelke@gmail.com'}</div>
			{/* <div style={{ textAlign: 'right', alignSelf: 'stretch' }}>{':מקימים'}</div>
			<div style={{ textAlign: 'right', alignSelf: 'stretch' }}>{'אוראל כאליהו'}</div>
			<div style={{ textAlign: 'right', alignSelf: 'stretch' }}>{'ניצן שלוטרבק לוי'}</div> */}
			<img
				src={MainLogo}
				style={{ display: 'flex', margin: 'auto', width: '30%', height: '30%' }}
				alt="fireSpot"
			/>
		</div>
	);
}
}
export default Contact;
